import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Button } from "./ui/button";
import { FileDown } from "lucide-react";

/**
 * Affiche les boutons de téléchargement des factures PDF disponibles
 * pour la mission donnée. Visible uniquement lorsque la mission est livrée + payée.
 */
export default function MissionInvoices({ mission }) {
  const [available, setAvailable] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!mission?.id) return;
    api.get(`/missions/${mission.id}/invoices`)
      .then(({ data }) => setAvailable(data.available || []))
      .catch(() => setAvailable([]))
      .finally(() => setLoading(false));
  }, [mission?.id, mission?.status, mission?.payment_status]);

  const openPdf = async (kind) => {
    try {
      const resp = await api.get(`/missions/${mission.id}/invoice.pdf?kind=${kind}`, {
        responseType: "blob",
      });
      const blob = new Blob([resp.data], { type: "application/pdf" });
      const url = URL.createObjectURL(blob);
      const w = window.open(url, "_blank", "noopener,noreferrer");
      if (!w) {
        const a = document.createElement("a");
        a.href = url;
        a.download = `facture-${mission.id.slice(0, 8)}.pdf`;
        a.click();
      }
      setTimeout(() => URL.revokeObjectURL(url), 60000);
    } catch (error) {
      console.error("Invoice download failed", error);
    }
  };

  if (loading || available.length === 0) return null;

  return (
    <div className="border border-[#1F4032]/10 rounded-md p-5 mt-6 bg-white" data-testid="mission-invoices">
      <div className="flex items-center gap-2 mb-3">
        <FileDown className="w-5 h-5 text-[#1F4032]" />
        <h3 className="font-display font-bold text-base tracking-tight">Documents comptables</h3>
      </div>
      <div className="flex flex-wrap gap-2">
        {available.map((inv) => (
          <Button
            key={inv.kind}
            onClick={() => openPdf(inv.kind)}
            variant="outline"
            size="sm"
            className="rounded-full border-[#1F4032] gap-2 hover:bg-[#1F4032] hover:text-white"
            data-testid={`invoice-${inv.kind}-btn`}
          >
            <FileDown className="w-3.5 h-3.5" /> {inv.label}
          </Button>
        ))}
      </div>
      <p className="text-xs text-neutral-500 mt-2">
        Les documents fiscaux sont proposés après livraison seulement si la société et le régime de TVA ont été validés. Conservez-les pour votre comptabilité.
      </p>
    </div>
  );
}
